import React, { useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { useTranslation } from 'helpers/hooks';

import { Events, eventsService, ShowClientMessageEvent } from '../../services/EventsService';
import Modal from '../../common/Modal';
import { logout } from '../../store/user/actions';
import storageService, { StorageKeys } from '../../services/StorageService';
import { appDep } from '../../config/settings';

export enum ErrorCodes {
  expiredToken = -3,
  notApproved = -4,
  insufficientBalance = -11,
  blockedInLyft = -5,
}

const ClientMessageModal: React.FC = function () {
  const [clientMessage, setClientMessage] = useState<{
    message: string;
    errorCode: number;
  } | null>(null);
  const { t } = useTranslation();
  const dispatch = useDispatch();

  useEffect(() => {
    const handleClientMessage = (e: ShowClientMessageEvent) => {
      const { message, errorCode } = e.detail;
      const isAllowedToShow = errorCode in ErrorCodes;

      if (!isAllowedToShow) {
        return;
      }

      if (errorCode === ErrorCodes.blockedInLyft) {
        return;
      }

      if (
        errorCode === ErrorCodes.notApproved &&
        storageService.getItem(StorageKeys.showNotAllowedSearchModal)
      ) {
        return;
      }

      setClientMessage({
        message,
        errorCode,
      });
    };

    eventsService.on(Events.ShowClientMessage, handleClientMessage);

    return () => {
      eventsService.off(Events.ShowClientMessage, handleClientMessage);
    };
  }, []);

  if (!clientMessage) {
    return null;
  }

  let title;
  let text: any = clientMessage.message;
  let applyText = '';
  let closeOnMask = true;
  let handleClose = () => setClientMessage(null);

  switch (clientMessage.errorCode) {
    case ErrorCodes.notApproved: {
      title = t('search.notAllowedModal.title');
      text = t('search.notAllowedModal.body', { appDep });
      applyText = t('search.notAllowedModal.buttonOk');
      handleClose = () => {
        storageService.setItem(StorageKeys.showNotAllowedSearchModal, '1');
        setClientMessage(null);
      };
      break;
    }
    case ErrorCodes.insufficientBalance: {
      text = (
        <>
          <p>{t('search.overbookedModal.body1')}</p>
          <p>{t('search.overbookedModal.body2')}</p>
        </>
      );
      applyText = t('search.overbookedModal.buttonOk');
      break;
    }
    case ErrorCodes.expiredToken: {
      text = t('search.expiredTokenModal.body', { appDep });
      applyText = t('search.expiredTokenModal.buttonOk');
      closeOnMask = false;
      handleClose = () => {
        setClientMessage(null);
        storageService.setItem(StorageKeys.showRegistrationTip, '1');
        dispatch(logout());
      };
      break;
    }
    default:
      return null;
  }

  return (
    <Modal
      title={title}
      applyText={applyText}
      showCancel={false}
      closeOnMask={closeOnMask}
      onClose={handleClose}
      onApply={handleClose}
    >
      {text}
    </Modal>
  );
};

export default ClientMessageModal;
